import type { FC } from 'react';
import type { MessageResponse } from '@/entities/conversations';
import { getMessagePersonName, getNoteContentSource } from '../model/messageText';
import { FeedBubble } from './FeedBubble';
import { MessageContent } from './MessageContent';

type Props = {
  /** Внутренняя заметка */
  message: MessageResponse;
};

/** Заметка: курсивом, без служебных упоминаний и лишних пустых строк. */
export const NoteFeedItem: FC<Props> = ({ message }) => (
  <FeedBubble
    messageId={message.id}
    kind="note"
    personName={getMessagePersonName(message.person)}
    createdAt={message.createdAt}
  >
    <MessageContent source={getNoteContentSource(message)} attachments={message.attachments} />
  </FeedBubble>
);
